export default __webpack_public_path__ + "static/img/top-space-md.a8562a9.jpg";